// extracted by mini-css-extract-plugin
module.exports = {"loader":"_28eZ7v"};